import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileConfigResBody,
  TDeviceProfileConfigSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileConfigsClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-config', TDeviceProfileConfigResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-config', TDeviceProfileConfigSummaryResBody> | undefined>;
};

function DeviceProfileConfigsClient(apiClient: TAPIClient): TDeviceProfileConfigsClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-config', TDeviceProfileConfigResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-config', TDeviceProfileConfigResBody>>(
        `/device-profile-configs/${id}`
      );

      if (data && data.type !== 'device-profile-config') {
        throw new Error('Invalid entity type received, expected: device-profile-config, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-config', TDeviceProfileConfigSummaryResBody> | undefined> {
      const data = await apiClient.get<
        TEntityListResponse<'device-profile-config', TDeviceProfileConfigSummaryResBody>
      >(`/device-profile-configs?limit=${limit}&page=${page}`);

      if (data && data.type !== 'device-profile-config') {
        throw new Error('Invalid entity type received, expected: device-profile-config, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileConfigsClient, DeviceProfileConfigsClient };
